angular.module("countries")

    .controller('CountriesListCtrl', ['$rootScope', '$scope', 'Restangular', 'gridService', 'modalService', 'uiGridConstants', '$filter', 'LoginService', '$state', 'treeService', 'uiGridTreeViewConstants', '$q', function ($rootScope, $scope, Restangular, gridService, modalService, uiGridConstants, $filter, LoginService, $state, treeService, uiGridTreeViewConstants, $q) {

        if (!LoginService.permissionExist("P_MODIFY_USER_COMPANY"))
            $state.go("countries.edit", { id: LoginService.get("countryId") });

        $rootScope.title = $filter('translate')('countries.title');
        $rootScope.breadcrumb = [
            { title: $filter('translate')('countries.list') }
        ];

        let filter = false;
       
        $scope.gridOptionsCountries = {
            pdfTitle: $filter('translate')('countries.pdf_title'),
            exporterMenuCsv: true,
            enableGridMenu: true,
            paginationPageSizes: [25, 50, 75],
            paginationPageSize: 25,
            onRegisterApi: function (gridApi) {
                this.gridApi = gridApi;
            },
            columnDefs: [
              { name: 'id', visible: false, enableHiding: false, exporterSuppressExport: true },
              { name: 'name', displayName: $filter('translate')('countries.name'), enableFiltering: true, enableHiding: false, enableColumnMenu: false },
              { name: 'code', displayName: $filter('translate')('countries.code'), enableFiltering: true, enableHiding: false, enableColumnMenu: false },
              {
                  name: ' ', width: 150, exporterSuppressExport: true, enableSorting: false, enableHiding: false, enableFiltering: false, enableColumnMenu: false, cellTemplate: gridService.actionTemplate([
                      { title: $filter('translate')('companies.button_edit'), action: 'ui-sref="countries.edit({id:row.entity.id})"', cssIconClass: "fa fa-edit" },
                      { title: $filter('translate')('companies.button_delete'), action: 'ng-click="grid.appScope.BorrarDialog(row.entity.id,row.entity.name);"', cssIconClass: "fa fa-remove" }
                  ], { cssClass: "pull-right" })
              },
            ],
            getData: function (options) {

                if (filter) {
                    options.name = $scope.countryFilter.name;
                    options.code = $scope.countryFilter.code;
                }

                 return Restangular.all('Countries').getList(options).then(function (result) {
                     return result;
                });
       
            }
            
        };

        $scope.goToEdit = function (rowEntity) {
            $state.go("countries.edit", { id: rowEntity.id });
        }

        $scope.search = function () {
            if (angular.isDefined($scope.gridOptionsCountries.loadData)) {
                filter = true;
                $scope.gridOptionsCountries.loadData();
            }
        }

        $scope.BorrarDialog = function (id,name) {
            $scope.id = id;
            $scope.name = name;
            modalService.confirm({
                title: $filter('translate')('countries.delete'),
                message: $filter('translate')('countries.delete_message') + " " + name + "?",
                onAccept: function () {
                    Restangular.one('Countries', $scope.id).remove().then(function () {
                        toastr.success($filter('translate')('companies.delete_success'));
                    $scope.gridOptionsCountries.gridApi.core.raise.itemDeleted($scope);
                        
                    }, function (response) {
                        $scope.errorMessage = response.message;
                    });
                }
            });

        };


    }])

;